import { useHistory, useLocation } from 'react-router';

import PropTypes from 'prop-types';

import { Box, Button, Paper, Skeleton } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { ModalDivider } from '../../Modal/ModalHandlerComponent';

import ModalTitle from '../../Modal/ModalTitle';

const ChooseCommunityComponent = (props) => {
  const { t } = useTransl();
  const history = useHistory();
  const { pathname } = useLocation();

  const { communityUnpagedList, isLoading } = props;

  return (
    <Paper elevation={0} sx={{ borderRadius: '1rem' }}>
      <ModalTitle>{t('community.chooseCommunity')}</ModalTitle>
      <ModalDivider />

      <Box sx={{ overflowX: 'hidden', padding: '2rem 1.8rem' }}>
        {isLoading
          ? Array.from({ length: 10 }).map((v, i) => (
              <Button
                key={i}
                sx={{ height: '5rem', textAlign: 'left' }}
                fullWidth
              >
                <Skeleton width="20rem" />
              </Button>
            ))
          : communityUnpagedList?.map(({ id, name }) => (
              <Button
                key={id}
                onClick={() => history.push(`${pathname}/${id}`)}
                sx={{ height: '5rem', textAlign: 'left' }}
                fullWidth
              >
                {name}
              </Button>
            ))}
      </Box>
    </Paper>
  );
};

ChooseCommunityComponent.propTypes = {
  communityUnpagedList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ChooseCommunityComponent;
